import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const takingSurveySelector = (state: State) =>
  state.takingSurvey.entities;
export const takingSurveyStatusSelector = (state: State) =>
  state.takingSurvey.status;

export const takingSurveyLoadedSelector = isLoaded(takingSurveyStatusSelector);
export const takingSurveyRejectedSelector = isRejected(
  takingSurveyStatusSelector,
);
export const takingSurveyPendingSelector = isPending(
  takingSurveyStatusSelector,
);
export const shouldLoadTakingSurveySelector = shouldLoad(
  takingSurveyStatusSelector,
);
